import FlashCardsScreen from './screen';
import { connect } from 'react-redux';
import {
  getFlashCardCountRequest, getFlashCardList,
  submitFlashCardDetails, flashCardIndex, update_flashcard_details,
  resetFlashCards,
} from '../../../redux/actions/index';

const mapStateToProps = state => {

  return {
    state,
    loading: state.LoadingReducer.isLoading,
    userId: state.CommonReducer.userId,
    sessionToken: state.CommonReducer.sessionToken,
    isNetConnected: state.LoginReducer.isNetConnected,
    FlashCardReducer: state.FlashCardReducer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getTotalFlashcards: (userId, success, errorSnackbar, value) =>
      dispatch(getFlashCardCountRequest(userId, success, errorSnackbar, value)),

    getListOfFlashCards: (flashcardDetails, errorSnackbar) =>
      dispatch(getFlashCardList(flashcardDetails, errorSnackbar)),

    submitFlashCardDetails: (userFlashcardDetails, errorSnackbar) =>
      dispatch(submitFlashCardDetails(userFlashcardDetails, errorSnackbar)),

    flashCardIndex: cardIndex => dispatch(flashCardIndex(cardIndex)),
    resetFlashCards: flashCards => dispatch(resetFlashCards(flashCards)),
    updateFlashCard: flashCards => dispatch(update_flashcard_details(flashCards)),

  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FlashCardsScreen);
